
import Button from '@/components/GettingStarted/Button.vue'
import CirclePercent from '@/components/GettingStarted/CirclePercent.vue'
import Icon from '@/components/UntitledUI/Icon.vue'

export default {
    name: 'GettingStarted',
    middleware: 'isSubscribe',
    components: {
        Button,
        Icon,
        CirclePercent
    },
    async asyncData ({ store, redirect, $axios, app, route }) {
        let steps = null
        try {
            if (store.getters['GettingStarted/isAllStepsDone']) {
                return redirect(app.localePath('/Search'))
            }

            steps = await $axios.$get('/v1/steps')
            if (!steps.length) {
                store.commit('GettingStarted/setIsAllStepsDone', true)
                return redirect(app.localePath('/Search'))
            }
            const stepsWithParent = steps.filter(s => s.parent_id)
            if (!stepsWithParent.length) {
                return redirect(app.localePath('/Search'))
            }
            if (stepsWithParent.filter(swp => swp.isDone).length === stepsWithParent.length) {
                store.commit('GettingStarted/setIsAllStepsDone', true)
                return redirect(app.localePath('/Search'))
            }
        } catch (e) {
            return redirect(app.localePath('/Search'))
        }

        return { steps }
    },
    data () {
        return {

        }
    },
    computed: {
        stepsByGroups () {
            return this.steps
                .map((s) => {
                    if (!s.parent_id) {
                        s.children = this.steps.filter(cs => cs.parent_id === s.id).sort((a, b) => a.order - b.order)
                    }
                    return s
                })
                .filter((s) => {
                    return s.children
                })
                .sort((a, b) => a.order - b.order)
        }
    },
    methods: {
        groupByKey (arr, key) {
            return arr.reduce(function (r, a) {
                r[r[key]] = r[key] || []
                r[r[key]].push(a)
                return r
            }, Object.create(null))
        },
        stepGroupIcon (step) {
            if (step.id === 'SearchForFile') {
                return 'search-normal'
            }

            if (step.id === 'MainTagFileOpened') {
                return 'document-1-copy'
            }

            if (step.id === 'OpenReferralStep') {
                return 'user-plus-02'
            }

            return 'document-1-copy'
        },
        stepDoBtnIcon (step) {
            if (step.parent_id === 'SearchForFile') {
                return 'search-normal'
            }

            if (step.parent_id === 'MainTagFileOpened') {
                return 'document-1'
            }

            if (step.parent_id === 'OpenReferral') {
                return 'gift'
            }

            return 'document-1-copy'
        },
        stepDoBtnText (step) {
            if (step.parent_id === 'SearchForFile') {
                return 'ابحث'
            }

            if (step.parent_id === 'MainTagFileOpened') {
                return 'فتح الملف'
            }

            if (step.parent_id === 'OpenReferral') {
                return 'ادع'
            }

            return 'document-1-copy'
        },
        doStep (step) {
            if (step.id === 'SearchForFile-1') {
                return this.$router.push(this.localePath('/Search'))
            }
            if (step.id === 'OpenReferral-1') {
                return this.$router.push(this.localePath('/Referral'))
            }
            if (step.parent_id === 'MainTagFileOpened') {
                return this.$router.push(this.localeRoute({
                    path: '/Search',
                    query: {
                        main: step.data.tag
                    }
                }))
            }
        },
        skipStep (step) {
            this.$axios.post('/v1/steps-dones', {
                step_id: step.id,
                is_skipped: true
            })
                .then(() => {
                    const stIndex = this.steps.findIndex(s => s.id === step.id)
                    const st = this.steps[stIndex]
                    st.isDone = true
                    this.$set(this.steps, stIndex, st)
                })
                .finally(() => {
                    if (this.groupsDoneCount() === this.stepsByGroups.length) {
                        this.$router.push(this.localePath('/Search'))
                    }
                })
        },
        doneCount (arrOfSteps) {
            return arrOfSteps.filter(s => s.isDone).length
        },
        groupsDoneCount () {
            return this.stepsByGroups.filter(sbg => sbg.children.filter(ch => ch.isDone).length === sbg.children.length).length
        },
        isAllDone (arrOfSteps) {
            return arrOfSteps.filter(s => s.isDone).length === arrOfSteps.length
        }
    },
    head: {
        title: 'الخطوات التعليمية'
    }
}
